module.exports = __webpack_public_path__ + "static/media/slipper.33533da6.svg";